<template>
  <div>
    <div v-if="!randLoaded" class="text-center">
      <b-spinner label="Loading..." style="color:#002b36;"></b-spinner>
    </div>
    <div v-else>
      <b-button class="kub-btn mb-3 float-right" v-b-modal.kub-modal-assistance>
        <b-icon icon="question" scale="1"></b-icon>
        <span>Hilfe</span>
      </b-button>
      <b-modal id="kub-modal-assistance" size="lg" centered ok-only scrollable :title="rand.assistance.title" title-tag="h2">
        <p class="kub-modal-assistance-header mb-2">{{rand.assistance.headingTop}}</p>
        <b-img-lazy id="kub-modal-assistance-img" :src="rand.assistance.img.src" center fluid :alt="rand.assistance.img.alt" class="mb-2"></b-img-lazy>
        <p class="kub-modal-assistance-header mb-2">{{rand.assistance.headingBottom}}</p>
        <div id="kub-modal-assistance-hints">
          <ul>
            <li v-for="(hint, index) in rand.assistance.desc" :key="index">{{hint}}</li>
          </ul>
        </div>
        <template #modal-footer="{ ok }">
          <b-button class="kub-btn" size="sm" @click="ok()">
            <span class="pl-2 pr-2">OK</span>
          </b-button>
        </template>
      </b-modal>
      <template v-if="!selectedHohlschnitt">
        <b-card no-body class="overflow-hidden">
          <b-row no-gutters>
            <b-col cols="12" sm="5" lg="12" xl="5" class="d-flex justify-content-center align-items-center kub-color-grey">
              <b-card-img-lazy :src="materialColorImg.schnittkante.src" :alt="materialColorImg.schnittkante.alt" fluid class="rounded-0 p-2"></b-card-img-lazy>
            </b-col>
            <b-col cols="12" sm="7" lg="12" xl="7">
              <b-card-body>
                <b-card-title title-tag="div">
                  <strong class="text-uppercase kub-color">{{rand.schnittkante.title.name}}</strong>
                  <small class="ml-2" v-if="randDefault">(vorausgewählt)</small>
                </b-card-title>
                <b-card-text>
                  <b-form-group label-cols="12" :label="rand.schnittkante.subtitle" label-align-sm="left">
                    <ul>
                      <li v-for="(side, index) in randSides" :key="side.id">
                        <b-form-radio v-model="side.type" button button-variant="outline-primary" :name="side.name" :value="rand.schnittkante.title" @change="setRandSchnittkante(index), setCalcSidesRand({ side: side.id-1, type: rand.schnittkante.title.name }), setCalcRand()">{{side.title}}</b-form-radio>
                      </li>
                    </ul>
                  </b-form-group>
                </b-card-text>
                <b-card no-body class="mb-1 pt-3 kub-no-border">
                  <b-card-header class="p-0 kub-no-border">
                      <b-button href="#" squared block v-b-toggle="rand.schnittkante.desc.toggle" variant="link" class="kub-btn-white text-decoration-none d-flex pl-0 pr-0">
                        <span class="m-0 text-left font-weight-bold text-uppercase">{{rand.schnittkante.desc.title}}</span>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="rand.schnittkante.desc.toggle">
                      <b-card-body class="p-1">
                        <b-card-text>
                          <p v-html="rand.schnittkante.desc.text" class="m-0"></p>
                        </b-card-text>
                      </b-card-body>
                  </b-collapse>
                </b-card>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
        <b-card no-body class="overflow-hidden">
          <b-row no-gutters>
            <b-col cols="12" sm="5" lg="12" xl="5" class="d-flex justify-content-center align-items-center kub-color-grey">
              <b-card-img-lazy :src="materialColorImg.saum.src" :alt="materialColorImg.saum.alt" fluid class="rounded-0 p-2"></b-card-img-lazy>
            </b-col>
            <b-col cols="12" sm="7" lg="12" xl="7">
              <b-card-body>
                <b-card-title title-tag="div">
                  <strong class="text-uppercase kub-color">{{rand.saum.titleSaum.name}}</strong>
                  <span v-if="activeSaum" class="kub-color float-right">(gesamt {{parseFloat(Math.round((calcSaumSidesTotal + Number.EPSILON) * 100) / 100).toFixed(2).replace(/\./g, ',')}} Lfm., +{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(calcSaumTotal)}})</span>
                </b-card-title>
                <b-card-text>
                  <b-form-group label-cols="12" :label="rand.saum.subtitleSaum" label-align-sm="left">
                    <ul>
                      <li v-for="side in randSides" :key="side.id">
                        <b-form-radio v-model="side.type" button button-variant="outline-primary" :name="side.name" :value="rand.saum.titleSaum" @change="setRandSaum({oesen: selectedOesenArt, id: side.id-1, oesenAnzahl: side.oesenAnzahl, drehverschluss: selectedDrehverschluss}), setCalcSidesRand({ side: side.id-1, type: rand.saum.titleSaum.name }), setCalcRand()">{{side.title}}</b-form-radio>
                      </li>
                    </ul>
                  </b-form-group>
                </b-card-text>
                <template v-if="activeSaum">
                  <p class="kub-color mb-4">
                    <small><strong>Hinweis:</strong> Der Saum wird auf der Rückseite verschweißt.</small>
                  </p>
                  <b-card-title title-tag="div">
                    <strong class="text-uppercase kub-color">{{rand.saum.titleOesen}}</strong>
                    <span v-if="activeOesenArt" class="kub-color float-right">(gesamt {{calcOesenAnzahlTotal}} Stück, +{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(calcOesenTotal)}})</span>
                  </b-card-title>
                  <b-card-text>
                    <b-form-group label-cols="12" :label="rand.saum.subtitleOesenart" label-align-sm="left">
                      <b-form-select v-model="selectedOesenArt" :options="rand.saum.optionsOesenart" @input="changeOesenArt($event), setCalcRand()"></b-form-select>
                    </b-form-group>
                    <template v-if="activeOesenArt">
                      <b-form-group label-cols="12" label-align-sm="left">
                        <template v-slot:label>
                          <b-row class="pt-1 pb-1" style="backgroundColor:rgba(0, 0, 0, 0.03);">
                            <b-col cols="7" md="8" xl="7">
                              <span class="font-weight-bold">{{rand.saum.subtitleOesenanzahl}}</span>
                            </b-col>
                            <b-col cols="5" md="4" xl="5" class="pr-0">
                              <span class="font-weight-bold mr-1">{{rand.saum.subtitleOesenabstand}}</span>
                              <b-icon icon="info-circle-fill" v-b-tooltip.hover title="Info" font-scale="1.25" class="ml-1" @click="$bvModal.show('kub-modal-oesenAbstand')" style="cursor:pointer;color:#002b36;"></b-icon>
                              <b-modal id="kub-modal-oesenAbstand" size="lg" centered>
                                <b-img-lazy id="kub-modal-oesenAbstand-img" :src="rand.saum.modalOesenabstand.img.src" center fluid :alt="rand.saum.modalOesenabstand.img.alt" class="mb-2"></b-img-lazy>
                                <p class="text-center">{{rand.saum.modalOesenabstand.desc}}</p>
                                <template #modal-footer="{ ok }">
                                  <b-button class="kub-btn" size="sm" @click="ok()">
                                    <span class="pl-2 pr-2">OK</span>
                                  </b-button>
                                </template>
                              </b-modal>
                            </b-col>
                          </b-row>
                        </template>
                        <div :class="{'kub-padding': md}">
                          <b-row v-for="side in activeSaumSides" :key="side.id">
                            <b-col cols="7" md="8" xl="7" class="mb-2">
                              <label :for="side.anzahlOesenID">Seite {{side.title}}:</label>
                              <b-form-spinbutton :id="side.anzahlOesenID" v-model="side.oesenAnzahl" min="0" max="50" @input="changeOesenAnzahl({oesenAnzahl: $event, id: side.id-1}), setCalcRand()"></b-form-spinbutton>
                            </b-col>
                            <b-col cols="5" md="4" xl="5" class="mb-2 d-flex align-items-end">
                              <div class="mb-2">ca.: {{oesenabstand(side.oesenAnzahl, calcSides[side.id-1])}}&nbsp;cm</div>
                            </b-col>
                          </b-row>
                        </div>
                      </b-form-group>
                      <template v-if="selectedOesenArt.drehverschluss">
                        <b-form-group label-cols="12" :label="rand.saum.subtitleDrehverschluss + ' (+' + new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((checkVAT ? (selectedOesenArt.price / (1 + VATRate)) : selectedOesenArt.price) * rand.saum.optionsDrehverschluss[0].value.factor) + '/Stück):'" label-align-sm="left" class="mt-2">
                          <b-form-radio-group id="kub-btn-selectedDrehverschluss" v-model="selectedDrehverschluss" :options="rand.saum.optionsDrehverschluss" buttons button-variant="outline-primary" name="kub-selectedDrehverschluss" @input="changeDrehverschluss($event), setCalcRand()"></b-form-radio-group>
                        </b-form-group>
                      </template>
                    </template>
                  </b-card-text>
                </template>
                <b-card no-body class="mb-1 pt-3 kub-no-border">
                  <b-card-header class="p-0" style="border-bottom:none;">
                      <b-button href="#" squared block v-b-toggle="rand.saum.desc.toggle" variant="link" class="kub-btn-white text-decoration-none d-flex pl-0 pr-0">
                        <span class="m-0 text-left font-weight-bold text-uppercase">{{rand.saum.desc.title}}</span>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="rand.saum.desc.toggle">
                      <b-card-body class="p-1">
                        <b-card-text>
                          <p v-html="rand.saum.desc.text" class="m-0"></p>
                        </b-card-text>
                      </b-card-body>
                  </b-collapse>
                </b-card>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
        <b-card no-body class="overflow-hidden">
          <b-row no-gutters>
            <b-col cols="12" sm="5" lg="12" xl="5" class="d-flex justify-content-center align-items-center kub-color-grey">
              <b-card-img-lazy :src="materialColorImg.hohlsaum.src" :alt="materialColorImg.hohlsaum.alt" fluid class="rounded-0 p-2"></b-card-img-lazy>
            </b-col>
            <b-col cols="12" sm="7" lg="12" xl="7">
              <b-card-body>
                <b-card-title title-tag="div">
                  <strong class="text-uppercase kub-color">{{rand.hohlsaum.title.name}}</strong>
                  <span v-if="activeHohlsaum" class="kub-color float-right">(gesamt {{parseFloat(Math.round((calcHohlsaumSidesTotal + Number.EPSILON) * 100) / 100).toFixed(2).replace(/\./g, ',')}} Lfm., +{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(calcHohlsaumTotal)}})</span>
                </b-card-title>
                <b-card-text>
                  <b-form-group label-cols="12" :label="rand.hohlsaum.subtitleHohlsaum" label-align-sm="left">
                    <ul>
                      <li v-for="(side, index) in randSides" :key="side.id">
                        <b-form-radio v-model="side.type" button button-variant="outline-primary" :name="side.name" :value="rand.hohlsaum.title" @change="setRandHohlsaum({id: index, breiteHohlsaum: selectedBreiteHohlsaum}), setCalcSidesRand({ side: side.id-1, type: rand.hohlsaum.title.name }), setCalcRand()">{{side.title}}</b-form-radio>
                      </li>
                    </ul>
                  </b-form-group>
                  <template v-if="activeHohlsaum">
                    <p class="kub-color mb-4">
                      <small><strong>Hinweis:</strong> Der Hohlsaum wird auf der Rückseite verschweißt.</small>
                    </p>
                    <b-form-group label-cols="12" :label="rand.hohlsaum.subtitleBreiteHohlsaum" label-align-sm="left">
                      <b-form-select v-model="selectedBreiteHohlsaum" :options="rand.hohlsaum.optionsBreiteHohlsaum" @input="changeBreiteHohlsaum($event), setCalcRand()"></b-form-select>
                    </b-form-group>
                  </template>
                </b-card-text>
                <b-card no-body class="mb-1 pt-3 kub-no-border">
                  <b-card-header class="p-0" style="border-bottom:none;">
                      <b-button href="#" squared block v-b-toggle="rand.hohlsaum.desc.toggle" variant="link" class="kub-btn-white text-decoration-none d-flex pl-0 pr-0">
                        <span class="m-0 text-left font-weight-bold text-uppercase">{{rand.hohlsaum.desc.title}}</span>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="rand.hohlsaum.desc.toggle">
                      <b-card-body class="p-1">
                        <b-card-text>
                          <p v-html="rand.hohlsaum.desc.text" class="m-0"></p>
                        </b-card-text>
                      </b-card-body>
                  </b-collapse>
                </b-card>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
        <template v-if="activeFormKeder">
          <b-card no-body class="overflow-hidden">
            <b-row no-gutters>
              <b-col cols="12" sm="5" lg="12" xl="5" class="d-flex justify-content-center align-items-center kub-color-grey">
                <b-card-img-lazy :src="materialColorImg.keder.src" :alt="materialColorImg.keder.alt" fluid class="rounded-0 p-2"></b-card-img-lazy>
              </b-col>
              <b-col cols="12" sm="7" lg="12" xl="7">
                <b-card-body>
                  <b-card-title title-tag="div">
                    <strong class="text-uppercase kub-color">{{rand.keder.title.name}}</strong>
                    <span v-if="activeKeder" class="kub-color float-right">(gesamt {{parseFloat(Math.round((calcKederSidesTotal + Number.EPSILON) * 100) / 100).toFixed(2).replace(/\./g, ',')}} Lfm., +{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(calcKederTotal)}})</span>
                  </b-card-title>
                  <b-card-text>
                    <b-form-group label-cols="12" :label="rand.keder.subtitleKeder" label-align-sm="left">
                      <ul>
                        <li v-for="(side, index) in randSides" :key="side.id">
                          <b-form-radio v-model="side.type" button button-variant="outline-primary" :name="side.name" :value="rand.keder.title" @change="setRandKeder({id: index, kederGroesse: selectedKederGroesse}), setCalcSidesRand({ side: side.id-1, type: rand.keder.title.name }), setCalcRand()">{{side.title}}</b-form-radio>
                        </li>
                      </ul>
                    </b-form-group>
                    <template v-if="activeKeder">
                      <b-form-group label-cols="12" :label="rand.keder.subtitleKederGroesse" label-align-sm="left">
                        <b-form-select v-model="selectedKederGroesse" :options="rand.keder.optionsKederGroesse" @input="changeKederGroesse($event), setCalcRand()"></b-form-select>
                      </b-form-group>
                    </template>
                  </b-card-text>
                  <b-card no-body class="mb-1 pt-3 kub-no-border">
                    <b-card-header class="p-0" style="border-bottom:none;">
                        <b-button href="#" squared block v-b-toggle="rand.keder.desc.toggle" variant="link" class="kub-btn-white text-decoration-none d-flex pl-0 pr-0">
                          <span class="m-0 text-left font-weight-bold text-uppercase">{{rand.keder.desc.title}}</span>
                          <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                          <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                        </b-button>
                    </b-card-header>
                    <b-collapse :id="rand.keder.desc.toggle">
                        <b-card-body class="p-1">
                          <b-card-text>
                            <p v-html="rand.keder.desc.text" class="m-0"></p>
                          </b-card-text>
                        </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </template>
      <template v-if="activeHohlschnittMaterial && activeFormHohlschnitt">
        <b-card no-body class="overflow-hidden">
          <b-row no-gutters>
            <b-col cols="12" sm="5" lg="12" xl="5" class="d-flex justify-content-center align-items-center kub-color-grey">
              <b-card-img-lazy :src="materialColorImg.hohlschnitt.src" :alt="materialColorImg.hohlschnitt.alt" fluid class="rounded-0 p-2"></b-card-img-lazy>
            </b-col>
            <b-col cols="12" sm="7" lg="12" xl="7">
              <b-card-body>
                <b-card-title title-tag="div">
                  <strong class="text-uppercase kub-color">{{rand.hohlschnitt.title.name}}</strong>
                </b-card-title>
                <b-card-text>
                  <b-form-group label-cols="12" :label="rand.hohlschnitt.subtitleHohlschnitt" label-align-sm="left" class="mt-2">
                    <b-form-radio-group id="kub-btn-selectedHohlschnitt" v-model="selectedHohlschnitt" :options="rand.hohlschnitt.optionsHohlschnitt" buttons button-variant="outline-primary" name="kub-selectedHohlschnitt" @input="setRandHohlschnitt(), setCalcSidesRandHohlschnitt(), setCalcRand(), scrollToId('kub-form-heading')"></b-form-radio-group>
                  </b-form-group>
                </b-card-text>
                <b-card no-body class="mb-1 pt-3 kub-no-border">
                  <b-card-header class="p-0" style="border-bottom:none;">
                      <b-button href="#" squared block v-b-toggle="rand.hohlschnitt.desc.toggle" variant="link" class="kub-btn-white text-decoration-none d-flex pl-0 pr-0">
                        <span class="m-0 text-left font-weight-bold text-uppercase">{{rand.hohlschnitt.desc.title}}</span>
                        <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                        <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                      </b-button>
                  </b-card-header>
                  <b-collapse :id="rand.hohlschnitt.desc.toggle">
                      <b-card-body class="p-1">
                        <b-card-text>
                          <p v-html="rand.hohlschnitt.desc.text" class="m-0"></p>
                        </b-card-text>
                      </b-card-body>
                  </b-collapse>
                </b-card>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </template>
      <b-row class="w-100 m-0">
        <b-col cols="12" offset-sm="5" sm="7" offset-lg="0" lg="12" offset-xl="5" xl="7" class="pl-0 pr-0">
          <b-row>
            <b-col cols="6">
              <b-button type="submit" href="#" v-b-toggle="setupComponents.material.toggle" block variant="link" class="kub-btn text-decoration-none d-flex align-items-center" @click="changeStatusMaterial(), scrollToId('kub-heading-setup')">
                <b-icon icon="chevron-left" font-scale="0.95"></b-icon>
                <span class="ml-auto mr-auto">Zurück</span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import DataSetup from '../../../../../data/main/config/setup/setup'
import DataService from './../../../../../services/DataService'

import { mapGetters, mapActions } from 'vuex'

import { mapMultiRowFields, mapFields } from 'vuex-map-fields'

export default {
  data () {
    return {
      rand: {},
      setupComponents: DataSetup.components,
      randLoaded: false
    }
  },
  methods: {
    ...mapActions([
      'changeStatusMaterial',
      'changeOesenArt',
      'changeOesenAnzahl',
      'changeDrehverschluss',
      'changeBreiteHohlsaum',
      'changeKederGroesse',
      'setRandSaum',
      'setRandSchnittkante',
      'setRandHohlsaum',
      'setRandKeder',
      'setRandHohlschnitt',
      'setCalcRand',
      'setCalcSidesRand',
      'setCalcSidesRandHohlschnitt',
      'setRandInitial',
      'randLoadingError'
    ]),
    oesenabstand (oesenanzahl, seitenlaenge) {
      if (oesenanzahl <= 1) {
        return '--'
      } else {
        if (this.activeKreis) {
          return Math.round(seitenlaenge / oesenanzahl)
        } else {
          return Math.round((seitenlaenge - 4) / (oesenanzahl - 1))
        }
      }
    },
    scrollToId (id) {
      document.getElementById(id).scrollIntoView()
    }
  },
  computed: {
    ...mapGetters([
      'width',
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      'activeSaum',
      'activeOesenArt',
      'activeHohlsaum',
      'activeKeder',
      'activeHohlschnittMaterial',
      'activeFormKeder',
      'activeFormHohlschnitt',
      'randSides',
      'configuration',
      'calcSides',
      'calcOesenAnzahlTotal',
      'calcOesenTotal',
      'activeKreis',
      'calcSaumSidesTotal',
      'calcSaumTotal',
      'calcHohlsaumSidesTotal',
      'calcHohlsaumTotal',
      'calcKederSidesTotal',
      'calcKederTotal',
      'materialColorImg',
      'randDefault',
      'checkVAT',
      'VATRate'
    ]),
    ...mapMultiRowFields(['randSides']),
    ...mapFields([
      'selectedOesenArt',
      'selectedDrehverschluss',
      'selectedBreiteHohlsaum',
      'selectedKederGroesse',
      'selectedHohlschnitt'
    ]),
    activeSaumSides () {
      return this.randSides.filter(el => {
        return el.type.name === this.rand.saum.titleSaum.name
      })
    }
  },
  async created () {
    try {
      this.rand = await DataService.getRand()
      this.setRandInitial()
      this.randLoaded = true
    } catch (err) {
      this.randLoadingError()
      console.log(err)
    }
  }
}
</script>

<style scoped>
.card {
  min-width: 100%;
  margin-bottom: 1rem;
}

#kub-modal-oesenAbstand-img {
  width: 100% !important;
  height: auto !important;
}

#kub-modal-assistance-img {
  width: 100% !important;
  min-height: 200px !important;
  height: auto !important;
}

img {
  width: 200px !important;
  height: 200px !important;
}

.card-header {
  border-bottom: none;
}

ul {
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

ul li {
  margin-right: 0.2em;
  margin-bottom: 0.2em;
  list-style: none;
  text-align: center;
  position: relative;
}

#kub-modal-assistance-hints > ul li {
  text-align: left;
  list-style: disc outside;
  margin-left: 1rem;
}

.kub-padding {
  padding-top: 7px;
}

#kub-icon-rand-assistance {
  cursor: pointer;
  color:#002b36;
  background-color: rgba(0, 0, 0, 0.02);
  border:1px solid transparent;
  border-color:#002b36 !important;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
}

#kub-icon-rand-assistance:hover {
  color: #fff !important;
  background-color: #002b36 !important;
  border-color: #002b36 !important;
}

.kub-modal-assistance-header {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.2;
}
</style>
